$(document).ready(function() {
  //product page sizeguide popup
if($(document).find('.itg_sizeguide_popup').length){
  $('.itg_sizeguide_popup').click(function(){
    $('.itg_size_popup').addClass('open');
    $('body').addClass('z_index');
  });
  $('.itg_popup_close').click(function(){
    $('.itg_size_popup').removeClass('open');
    $('body').removeClass('z_index');
  });
}
  //Product page vertical slider
if($(document).find('.slider-for').length){
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav',
    responsive: [
    {
        breakpoint: 749,
        settings: {
          dots: true,
        }
    }
      ]
});
$('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none"><path d="M13 5.79932L7 0.799315L1 5.79932" stroke="#121212" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none"><path d="M1 0.799316L7 5.79932L13 0.799316" stroke="#121212" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
    {
        breakpoint: 992,
        settings: {
          vertical: true,
          slidesToShow: 4,
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: true,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 749,
      settings: {
        vertical: false,
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 380,
      settings: {
        vertical: false,
        slidesToShow: 2,
      }
    }
    ]
});
}

$('.product__info-wrapper .product-form__input input[type=radio]').on('change',function(){
   setTimeout(function(){
     $(document).find('.slider-nav button.thumbnail[aria-current="true"]').trigger('click');
    },500);
});
 
                             
});